import track from './eventTracker';

export const trackRemoveItem = ({
  source,
  collection,
  skuId,
  externalProductId,
}) => {
  return track({
    event_name: 'kept_item.remove_item.open_modal',
    canonical_name: 'pdp',
    action_type: 'click',
    action_name: 'remove_kept_item',
    sku_id: skuId,
    external_product_id: externalProductId,
    source,
    collection,
  });
};
export const trackConfirmRemoveItem = ({
  source,
  collection,
  skuId,
  feedback,
  externalProductId,
}) => {
  return track({
    event_name: 'kept_item.remove_item.confirm',
    canonical_name: 'pdp',
    action_type: 'click',
    action_name: 'confirm_remove_kept_item',
    sku_id: skuId,
    external_product_id: externalProductId,
    source,
    collection,
    feedback,
  });
};

export const trackCancelRemoveItem = ({
  source,
  collection,
  skuId,
  externalProductId,
}) => {
  return track({
    event_name: 'kept_item.remove_item.cancel',
    canonical_name: 'pdp',
    action_type: 'click',
    action_name: 'cancel_remove_kept_item',
    sku_id: skuId,
    external_product_id: externalProductId,
    source,
    collection,
  });
};
